import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

export function Barcode({ value, height = 28, width = 1, fontSize = 9, testid }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && value) {
      JsBarcode(ref.current, String(value), { format: "CODE128", height, width, fontSize, margin: 2, displayValue: true });
    }
  }, [value, height, width, fontSize]);
  return <svg ref={ref} className="mx-auto max-w-full" data-testid={testid} />;
}
